import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { CalendarPlus, Plus } from 'lucide-react';
import { CardType, ColumnProps } from '../../types/index';
import { ColumnStyled, ColumnHeader, ColumnCountBadge, CardsContainer, AddCardButton, getColumnColor } from '../../styles/index';
import DraggableCard from '../DraggableCard';
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { HeaderRow, ColorDot, HeaderMeta, ColumnName } from './styles';

function Column({
  column,
  boardId,
  onOpenCard,
  onOpenNewCard,
  onOpenCreateFromSchedule,
  canCreateFromSchedule,
  columnIndex,
  warningCardId,
  zoomLevel,
}: ColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id: column.id });
  const cardCount = column?.cards?.data?.length || 0;

  return (
    <ColumnStyled $zoom={zoomLevel} $isDropTarget={isOver}>
      <ColumnHeader $columnIndex={columnIndex}>
        <HeaderRow>
          <ColorDot $color={getColumnColor(columnIndex ?? 0)} />
          <HeaderMeta>
            <ColumnName>{column.name}</ColumnName>
            <ColumnCountBadge>{cardCount}</ColumnCountBadge>
          </HeaderMeta>
        </HeaderRow>

        {columnIndex === 0 && (
          <div className="flex items-center">
            {canCreateFromSchedule && (
              <AddCardButton
                type="button"
                title="Criar card a partir de agendamento"
                aria-label="Criar card a partir de agendamento"
                onClick={onOpenCreateFromSchedule}
              >
                <CalendarPlus />
              </AddCardButton>
            )}
            <AddCardButton
              type="button"
              title="Criar card em branco"
              aria-label="Criar card em branco"
              onClick={() => onOpenNewCard(column.id)}
            >
              <Plus />
            </AddCardButton>
          </div>
        )}
      </ColumnHeader>
      <CardsContainer ref={setNodeRef} $isDropTarget={isOver} $empty={cardCount === 0}>
        <SortableContext items={column?.cards?.data?.map(card => String(card.id)) ?? []} id={String(column.id)} strategy={verticalListSortingStrategy}>
          {column?.cards?.data?.map((card: CardType) => (
            <DraggableCard
              key={card.id}
              card={card}
              onOpenCard={() => onOpenCard({ ...(card as any), column_name: column.name } as CardType)}
              boardId={boardId}
              columnId={column.id}
              isWarning={warningCardId === card.id}
            />
          ))}
        </SortableContext>
      </CardsContainer>
    </ColumnStyled>
  );
}

export default Column;
